import './Button.scss'
import React, { PropTypes } from 'react'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

const Button = ({
  to,
  href,
  type,
  onClick,
  children,
  disabled,
  styleType,
  className
}) => {
  const Component = to ? Link : href ? 'a' : 'button'
  return (
    <Component
      className={classnames('Button', `Button-${styleType}`, className)}
      disabled={disabled}
      onClick={onClick}
      href={href}
      type={type}
      to={to}>
      {children}
    </Component>
  )
}

Button.displayName = 'Button'

Button.propTypes = {
  styleType: PropTypes.oneOf(['default', 'primary', 'blank']).isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  href: PropTypes.string,
  to: PropTypes.string
}

Button.defaultProps = {
  styleType: 'default',
  onClick: () => {},
  type: 'button'
}

export default Button



// WEBPACK FOOTER //
// ./src/lib/Button.js